import React from 'react';
import ReactPlayer from 'react-player';
import './App.css';

function App() {
  const [playing, setPlaying] = React.useState(false);
  const joinMeeting = () => {
    const options = {
      roomName: 'yzyzyziostest',
      width: '100%',
      height: '100%',
      parentNode: document.querySelector('#meet')
    };
    new window['JitsiMeetExternalAPI']('meet.jit.si', options);
  }
  const sampleMp4VideoUrl = `https://static.inspify.io/playground/ios_webrtc_audio/iris_introduction.mp4`;
  const sampleM3u8VideoUrl = `https://videos.inspify.io/content/converted/7a88d223-a4c6-4156-8545-f6c650afa6af/iris_introduction.mp4/index.m3u8`;
  return (
    <div className="App">
      <header className="App-header">
        <ReactPlayer
          className="video-player"
          width="100%"
          playing={playing}
          url={sampleM3u8VideoUrl}
          playsinline
          controls
         />
        <div className='buttons'>
          <button onClick={joinMeeting}>JOIN MEETING</button>
          <button onClick={() => {
            setPlaying(true);
          }}>PlayVideo</button>
        </div>
        <div id="meet"></div>
      </header>
    </div>
  );
}

export default App;
